import script from "./InCuartoFrio.vue?vue&type=script&lang=ts&setup=true"
export * from "./InCuartoFrio.vue?vue&type=script&lang=ts&setup=true"

import "./InCuartoFrio.vue?vue&type=style&index=0&id=809ae11a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-809ae11a"]])

export default __exports__